// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay */
.MoneyActionModal_overlay__ovAr4 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal container */
.MoneyActionModal_container__vzgJx {
  width: 360px;
  background: #ffffff;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: MoneyActionModal_fadeIn__EjbU1 0.2s ease;
}

/* Header */
.MoneyActionModal_header__nKAiz {
  margin-bottom: 16px;
}

.MoneyActionModal_title__e19hP {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

/* Info block */
.MoneyActionModal_info__r05yS {
  background: #f9fafb;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 16px;
}

.MoneyActionModal_infoLabel__c6eg6 {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}

.MoneyActionModal_balance__QY6Ww {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #374151;
}

.MoneyActionModal_balanceValue__MxIAT {
  font-weight: 600;
  color: #111827;
}

/* Input */
.MoneyActionModal_inputBlock__eyFG6 {
  margin-bottom: 20px;
}

.MoneyActionModal_inputLabel__K5tZH {
  display: block;
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 6px;
}

.MoneyActionModal_input__rmoMx {
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  outline: none;
}

.MoneyActionModal_input__rmoMx:focus {
  border-color: rgba(24, 115, 70, 1);
}

/* Actions */
.MoneyActionModal_actions__o-3Np {
  display: flex;
  gap: 10px;
}

/* Buttons */
.MoneyActionModal_cancelButton__lOe-i {
  flex: 1 1;
  background: #e5e7eb;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
}

.MoneyActionModal_cancelButton__lOe-i:hover {
  background: #d1d5db;
}

.MoneyActionModal_depositButton__1z8pL {
  flex: 1 1;
  background: rgba(24, 115, 70, 1);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
}

.MoneyActionModal_depositButton__1z8pL:hover {
  background: rgba(24, 115, 70, 0.5);
}

.MoneyActionModal_withdrawButton__Rk\\+pM {
  flex: 1 1;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px;
  font-size: 14px;
  cursor: pointer;
}

.MoneyActionModal_withdrawButton__Rk\\+pM:hover {
  background: #dc2626;
}

/* Animation */
@keyframes MoneyActionModal_fadeIn__EjbU1 {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FinanceView/MoneyActionModal.module.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,mDAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/* Overlay */\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Modal container */\n.container {\n  width: 360px;\n  background: #ffffff;\n  border-radius: 14px;\n  padding: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.2s ease;\n}\n\n/* Header */\n.header {\n  margin-bottom: 16px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Info block */\n.info {\n  background: #f9fafb;\n  border-radius: 10px;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.infoLabel {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.balance {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  color: #374151;\n}\n\n.balanceValue {\n  font-weight: 600;\n  color: #111827;\n}\n\n/* Input */\n.inputBlock {\n  margin-bottom: 20px;\n}\n\n.inputLabel {\n  display: block;\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 6px;\n}\n\n.input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  font-size: 14px;\n  outline: none;\n}\n\n.input:focus {\n  border-color: rgba(24, 115, 70, 1);\n}\n\n/* Actions */\n.actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* Buttons */\n.cancelButton {\n  flex: 1;\n  background: #e5e7eb;\n  border: none;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.cancelButton:hover {\n  background: #d1d5db;\n}\n\n.depositButton {\n  flex: 1;\n  background: rgba(24, 115, 70, 1);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.depositButton:hover {\n  background: rgba(24, 115, 70, 0.5);\n}\n\n.withdrawButton {\n  flex: 1;\n  background: #ef4444;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.withdrawButton:hover {\n  background: #dc2626;\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `MoneyActionModal_overlay__ovAr4`,
	"container": `MoneyActionModal_container__vzgJx`,
	"fadeIn": `MoneyActionModal_fadeIn__EjbU1`,
	"header": `MoneyActionModal_header__nKAiz`,
	"title": `MoneyActionModal_title__e19hP`,
	"info": `MoneyActionModal_info__r05yS`,
	"infoLabel": `MoneyActionModal_infoLabel__c6eg6`,
	"balance": `MoneyActionModal_balance__QY6Ww`,
	"balanceValue": `MoneyActionModal_balanceValue__MxIAT`,
	"inputBlock": `MoneyActionModal_inputBlock__eyFG6`,
	"inputLabel": `MoneyActionModal_inputLabel__K5tZH`,
	"input": `MoneyActionModal_input__rmoMx`,
	"actions": `MoneyActionModal_actions__o-3Np`,
	"cancelButton": `MoneyActionModal_cancelButton__lOe-i`,
	"depositButton": `MoneyActionModal_depositButton__1z8pL`,
	"withdrawButton": `MoneyActionModal_withdrawButton__Rk+pM`
};
export default ___CSS_LOADER_EXPORT___;
